<template>
    <div class="flex flex-row gap-1">
        <UButton
            variant="outline"
            color="neutral"
            :icon="documentMeta.isDeleted ? '' : 'i-ph-file-magnifying-glass'"
            :disabled="documentMeta.isDeleted"
            :class="documentMetaUuid === selectedDocumentMetaUuid ? 'ring-2 ring-inverted ' : ''"
            :active="documentMetaUuid === selectedDocumentMetaUuid"
            @click="onClickDocumentLink(documentMetaUuid)"
            @mouseover="onHoverDocumentLink(documentMetaUuid)"
        >
            {{ documentMeta.filename }}
        </UButton>
        <UTooltip
            v-if="hasDelete"
            :title="`Fjern ${documentMeta.filename}`"
        >
            <UButton
                icon="i-ph-trash"
                variant="outline"
                color="error"
                @click="emit('onClickDelete',documentMetaUuid)"
            />
        </UTooltip>
    </div>
</template>

<script setup lang="ts">

import {DocumentMeta} from '@/types/transaction/DocumentMeta'
import {useDocumentPreviewModalService} from '@/transaction-journal/DocumentPreview.modal.service'
import {computed} from 'vue'

const props = defineProps({
    documentMeta: {
        type: Object as () => DocumentMeta,
        required: true
    },
    hasDelete: {
        type: Boolean,
        default: false
    }
})

const emit = defineEmits(['onClickDelete'])

const {onClickDocumentLink, onHoverDocumentLink, selectedDocumentMetaUuid} = useDocumentPreviewModalService()

const documentMetaUuid = computed(() => props.documentMeta.uuid)

</script>

<style>

</style>